import React, { useState } from 'react'
import Text from '../../../../Text'
import styles from './styles.module.css'
import perksStyles from '../styles.module.css'
import CheckmarkIconRed from '../../../../icons/CheckmarkIconRed'
import CloseIcon from '../../../../icons/CloseIcon'

function Perk({ title, textContent, icon, noPadding, noBorder }) {
  const [showPopUp, setShowPopUp] = useState(false)

  const perkWrapperClasses = [perksStyles.perkWrapper]
  if (noBorder) perkWrapperClasses.push(perksStyles.perkWrapperNoBorder)
  if (noPadding) perkWrapperClasses.push(perksStyles.perkWrapperNoPadding)

  return (
    <>
      <div
        className={perkWrapperClasses.join(' ')}
        onClick={() => setShowPopUp(!showPopUp)}
      >
        <div className={perksStyles.perkIcon}>
          {icon || <CheckmarkIconRed/>}
        </div>
        <div className={perksStyles.perkText}>
          <Text type="small">{title}</Text>
        </div>
      </div>
      <div className={`${styles.backdrop}${showPopUp ? ' ' + styles.backdropShown : ''}`} onClick={() => setShowPopUp(false)}/>
      <div className={`${styles.popUp}${showPopUp ? ' ' + styles.popUpShown : ''}`}>
        <div className={styles.closeIconWrapper} onClick={() => setShowPopUp(false)}>
          <CloseIcon/>
        </div>
        { textContent }
      </div>
    </>
  )
}

export default Perk
